import packageInfo from '../../package.json';

export const environment = {
	appVersion: packageInfo.version,
	production: false,
	API_DOMAIN: 'https://back-vira.betacore.pro',
	TRACKING_API_DOMAIN: 'https://gps.rastreo.betacore.pro',
	WEBSOCKET_URL: 'wss://back-dev-notification-vira.betacore.pro/notifications',
	googleMapsApiKey: 'AIzaSyCm5KxfafwEaEu9U8SLzIoMo5kgWK3nlTg',
	googlePlay: 'https://play.google.com/store/apps/details?id=com.wipa.passenger',
	appStore: 'https://apps.apple.com/co/app/wipa-pasajero/id6754669799',
	SERVICES: {
		SECURITY: `/api/v1`,
		DRIVERS: `/api/v1`,
		PASSENGERS: `/api/v1`,
		BRANDS: `/api/v1/vehicle-brands`,
		CATEGORY: `/api/v1/vehicle-category`,
		VEHICLES: `/api/v1`,
		DOCUMENT: `/api/v1`,
		LENGUAGE: `/api/v1`,
		ADMIN: `/api/v1/`,
		ENTERPRISE: `/api/v1/`,
		PARAMETERS: `/api/v1`,
		COUPON: `/api/v1/coupons`,
		IDENTIFICATION_TYPE: `/api/v1`,
		SERVICES_GESTION: `/api/v1`,
		GENDER: `/api/v1`,
		RATES: `/api/v1`,
		PRE_OPERATIONAL: `/api/v1`,
		FUEC_CONFIG: `/api/v1/fuec/fuec-config`,
		DASHBOARD: `/api/v1/dashboards`,
		PUSH_NOTIFICATIONS: `/api/v1/push-notifications`,
		USER_NOTIFICATIONS: `/api/v1/user/notifications`,
		LICENSES: `/api/v1/licenses`,
		BENEFICIARIES: `/api/v1/`,
		FUEC: `/api/v1/fuec`,
		APP_VERSIONS: `/api/v1/app-versions`,
		MERCHANDISE: `/api/v1/merchandise`,
		HELPLINES: `/api/v1`,
		PLANNED_ROUTES: `/api/v1/planned-routes`,
		FIELDS_FORMS: `/api/v1`,
		TABLE_VIEW_TEMPLATES: `/api/v1/table-view-templates`,
		TABLE_VIEW_PREFERENCES: `/api/v1/table-view-preferences`
	}
};
